import { render } from "./TeamAdminTools.vue?vue&type=template&id=635c2b24&scoped=true"
import script from "./TeamAdminTools.vue?vue&type=script&lang=js"
export * from "./TeamAdminTools.vue?vue&type=script&lang=js"

import "./TeamAdminTools.vue?vue&type=style&index=0&id=635c2b24&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635c2b24"]])

export default __exports__